import { useEffect, useState } from 'react'
import DImage from "../assets/Image/default_pic.png";
const ImageLoad = ({ src, alt, CustomeStyle, index }) => {

    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);

    if (error || !src) {
        if (index === 1) {
            return <img src={DImage} className={CustomeStyle} alt="default_pic" />
        }
        return <div className={`${CustomeStyle} shimmer`}></div>
    }

    return (
        <img
            src={src}
            alt={alt}
            className={`${CustomeStyle} transition-opacity duration-300 ${loaded ? "opacity-100" : "opacity-0"}`}
            onLoad={() => setLoaded(true)}
            onError={() => setError(true)}
        />
    )
}

export default ImageLoad